import PeopleIcon from "@mui/icons-material/People";
import { ErasmusServicePath, COORDINATORS_ERASMUS } from "utils/constants";
import { tenants } from "utils/tenants";
import permissions from "app/permissions";
import ListErasmusCoordinators from "./List";
import CreateErasmusCoordinators from "./Create";
import EditErasmusCoordinators from "./Edit";
import ShowErasmusCoordinators from "./Show";

export const resources = {
  isMenu: true,
  icon: <PeopleIcon />,
  tenancies: [tenants.MU],
  name: `${ErasmusServicePath}${COORDINATORS_ERASMUS}`,
  title: "Координатори",
  list: <ListErasmusCoordinators />,
  create: <CreateErasmusCoordinators />,
  edit: <EditErasmusCoordinators />,
  show: <ShowErasmusCoordinators />,
  permission: permissions.canPreviewErasmusCoordinators,
  createPermission: permissions.canManageErasmusCoordinators,
  editPermission: permissions.canManageErasmusCoordinators,
  showPermission: permissions.canPreviewErasmusCoordinators,
};
